import { useState } from "react";
import Input from "../../components/preview-input/input";
import useOrderStore from "../../store/order-store";
import { useLocation } from "react-router-dom";

function FlexGroundspoutSelection() {

  const { orderData,  setFormData } = useOrderStore();
  const flexGroundspoutNeeded = orderData.groundSpoutNeeded;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hasSheet = queryParams.get('hasSheet');
  const isDisabled =(hasSheet === 'true');
  const handleInputChange = (value) => {
    if(isDisabled){
      return
    }
    setFormData({ 
      ...orderData,
      groundSpoutNeeded: value
     });
  };
  const handleInputChange2 = (field) => (e) => {
    setFormData({
      ...orderData,
      [field]: e.target.value
    });
  };
  return (
    <div className="k-display-flex k-flex-wrap k-mt-1">
      <h4 className="k-m-0 k-font-light k-pt-2 k-d-flex-sm-cloumn">
        Flex. Groundspout Needed:&nbsp;
        <label className="k-ml-sm-0" style={{ marginRight: "8px" }}>
          <input
          disabled={isDisabled}
            type="radio"
            name="flexGroundspoutNeeded"
            value="Yes"
            checked={flexGroundspoutNeeded === "Yes"}
            onChange={() => handleInputChange("Yes")}
            style={{ marginRight: "8px" }}
            className="k-ml-sm-0"
          />
          Yes
        </label>
        <label className="k-ml-sm-0" style={{ marginLeft: "8px" }}>
          <input
          disabled={isDisabled}
            type="radio"
            name="flexGroundspoutNeeded"
            value="No"
            checked={flexGroundspoutNeeded === "No"}
            onChange={() => handleInputChange("No")}
            style={{ marginRight: "8px" }}
            className="k-ml-sm-0"
          />
          No
        </label>
        &nbsp; Units:
      </h4>

      <div className="k-pos-relative k-top-1 k-ml-4 k-sm-w-100 k-ml-sm-0" style={{ width: "100px" }}>
        <Input value={orderData.units} onChange={handleInputChange2('units')} type="number"/>
      </div>
    </div>
  );
}

export default FlexGroundspoutSelection;
